(function () {
  let KEY = 'gsTopDiscountBanner';

  if (window[KEY]) {
    window[KEY].refresh();
    return;
  }

  let instances = new Map();

  function initialise(root) {
    if (instances.has(root)) return;

    let track = root.querySelector('[data-track]');
    if (!track) return;

    let slides = Array.from(track.children);
    let previous = root.querySelector('[data-prev]');
    let next = root.querySelector('[data-next]');
    let pauseButton = root.querySelector('[data-pause]');
    let pauseIcon = root.querySelector('[data-pause-icon]');
    let status = root.querySelector('[data-status]');

    if (!slides.length || !previous || !next) return;

    let events = new AbortController();
    let motion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    let index = 0;
    let targetIndex = 0;
    let busy = false;
    let paused = motion.matches || root.dataset.autoplay !== 'true';
    let hovered = false;
    let focused = root.contains(document.activeElement);
    let destroyed = false;
    let timer;
    let frame;

    /* Timing in milliseconds. */
    let HOLD_TIME = Number(root.dataset.interval) || 5000;
    let DELETE_SPEED = 14;
    let TYPE_SPEED = 26;

    function listen(target, name, handler) {
      if (!target) return;

      target.addEventListener(name, handler, {
        signal: events.signal
      });
    }

    /*
      Store the original text nodes.
      No character wrappers or character visibility rules are used.
    */
    let data = slides.map(function (slide) {
      let message = slide.querySelector('.gs-banner__message');
      message.normalize();

      let walker = document.createTreeWalker(
        message,
        NodeFilter.SHOW_TEXT
      );

      let records = [];
      let node;

      while ((node = walker.nextNode())) {
        if (
          node.textContent.trim() &&
          !node.parentElement.closest('svg')
        ) {
          records.push({
            node: node,
            original: node.textContent,
            characters: Array.from(node.textContent)
          });
        }
      }

      return {
        slide: slide,
        message: message,
        records: records,
        action:
          slide.querySelector('.gs-banner__actions') ||
          slide.querySelector(':scope > .gs-banner__cta'),
        ornament: message.querySelector(
          '.gs-banner__badge, .gs-banner__icon'
        ),
        locked: []
      };
    });

    function restoreText(item) {
      item.records.forEach(function (record) {
        record.node.textContent = record.original;
      });
    }

    function showSlide(selected) {
      data.forEach(function (item, itemIndex) {
        let active = itemIndex === selected;

        item.slide.style.visibility = active ? 'visible' : 'hidden';
        item.slide.style.pointerEvents =
          active && !busy ? '' : 'none';

        item.slide.setAttribute(
          'aria-hidden',
          active ? 'false' : 'true'
        );

        item.slide.toggleAttribute(
          'inert',
          !active || busy
        );
      });
    }

    function stopTimer() {
      window.clearTimeout(timer);
    }

    function schedule() {
      stopTimer();

      if (
        destroyed ||
        busy ||
        paused ||
        hovered ||
        focused ||
        document.hidden ||
        !root.isConnected
      ) return;

      timer = window.setTimeout(function () {
        change(1, false);
      }, HOLD_TIME);
    }

    function visibleRecords(item) {
      return item.records.filter(function (record) {
        return record.node.parentElement.getClientRects().length > 0;
      });
    }

    function characterCount(records) {
      return records.reduce(function (total, record) {
        return total + record.characters.length;
      }, 0);
    }

    function writeCharacters(records, amount) {
      let remaining = amount;

      records.forEach(function (record) {
        let length = Math.max(
          0,
          Math.min(record.characters.length, remaining)
        );

        record.node.textContent =
          record.characters.slice(0, length).join('');

        remaining -= record.characters.length;
      });
    }

    /*
      Hold the message at its completed dimensions while typing,
      keeping buttons and surrounding spacing in place.
    */
    function lockLayout(item) {
      let elements = [
        item.message,
        item.message.querySelector('.gs-banner__text'),
        item.message.querySelector('.gs-banner__offer-text'),
        item.message.querySelector('.gs-banner__badge')
      ].filter(Boolean);

      /* Measure everything before applying any temporary styles. */
      let measurements = elements.map(function (element) {
        return {
          element: element,
          rect: element.getBoundingClientRect(),
          style: element.getAttribute('style')
        };
      });

      item.locked = measurements;

      measurements.forEach(function (saved) {
        if (saved.rect.width > 0 && saved.rect.height > 0) {
          saved.element.style.width = saved.rect.width + 'px';
          saved.element.style.minHeight = saved.rect.height + 'px';
          saved.element.style.flexShrink = '0';
        }
      });
    }

    function unlockLayout(item) {
      item.locked.forEach(function (saved) {
        if (saved.style === null) {
          saved.element.removeAttribute('style');
        } else {
          saved.element.setAttribute('style', saved.style);
        }
      });

      item.locked = [];
    }

    function settle() {
      window.cancelAnimationFrame(frame);

      index = targetIndex;
      busy = false;

      data.forEach(function (item) {
        restoreText(item);
        unlockLayout(item);

        if (item.action) {
          item.action.style.opacity = '';
        }

        if (item.ornament) {
          item.ornament.style.opacity = '';
        }
      });

      showSlide(index);
    }

    function change(direction, manual) {
      if (destroyed) return;

      if (busy) settle();

      stopTimer();

      let outgoing = data[index];

      targetIndex = (
        index + direction + data.length
      ) % data.length;

      let incoming = data[targetIndex];

      if (motion.matches) {
        settle();

        if (manual && status) {
          status.textContent =
            incoming.slide.getAttribute('aria-label');
        }

        schedule();
        return;
      }

      restoreText(outgoing);
      restoreText(incoming);

      lockLayout(outgoing);
      lockLayout(incoming);

      let oldRecords = visibleRecords(outgoing);
      let newRecords = visibleRecords(incoming);
      let oldLength = characterCount(oldRecords);
      let newLength = characterCount(newRecords);

      busy = true;
      showSlide(index);

      writeCharacters(newRecords, 0);

      if (incoming.action) {
        incoming.action.style.opacity = '0';
      }

      if (incoming.ornament) {
        incoming.ornament.style.opacity = '0';
      }

      let eraseStart = 200;
      let eraseEnd =
        eraseStart + Math.max(100, oldLength * DELETE_SPEED);

      let switchTime = eraseEnd + 140;
      let typeStart = switchTime + 100;
      let typeEnd =
        typeStart + Math.max(160, newLength * TYPE_SPEED);

      let revealStart = typeEnd + 120;
      let endTime = revealStart + 240;

      let started = null;
      let switched = false;

      function progress(elapsed, start, end) {
        return Math.max(
          0,
          Math.min(1, (elapsed - start) / (end - start))
        );
      }

      function tick(now) {
        if (destroyed) return;

        if (started === null) started = now;

        let elapsed = now - started;

        if (elapsed < switchTime) {
          /* Fade the current buttons away. */
          if (outgoing.action) {
            outgoing.action.style.opacity = String(
              1 - progress(elapsed, 0, eraseStart)
            );
          }

          /* Delete the old message from right to left. */
          writeCharacters(
            oldRecords,
            Math.ceil(
              oldLength *
              (1 - progress(elapsed, eraseStart, eraseEnd))
            )
          );

          if (outgoing.ornament) {
            outgoing.ornament.style.opacity = String(
              1 - progress(elapsed, eraseEnd, switchTime)
            );
          }
        } else {
          if (!switched) {
            switched = true;
            showSlide(targetIndex);
          }

          if (incoming.ornament) {
            incoming.ornament.style.opacity = String(
              progress(elapsed, switchTime, switchTime + 180)
            );
          }

          /* Type the new message from left to right. */
          writeCharacters(
            newRecords,
            Math.floor(
              newLength * progress(elapsed, typeStart, typeEnd)
            )
          );

          /* Reveal the buttons once typing has finished. */
          if (incoming.action) {
            incoming.action.style.opacity = String(
              progress(elapsed, revealStart, endTime)
            );
          }
        }

        if (elapsed < endTime) {
          frame = window.requestAnimationFrame(tick);
        } else {
          settle();

          if (manual && status) {
            status.textContent =
              incoming.slide.getAttribute('aria-label');
          }

          schedule();
        }
      }

      frame = window.requestAnimationFrame(tick);
    }

    function updatePauseButton() {
      if (!pauseButton) return;

      pauseButton.setAttribute(
        'aria-label',
        paused
          ? root.dataset.resumeLabel
          : root.dataset.pauseLabel
      );

      if (pauseIcon) {
        pauseIcon.setAttribute(
          'd',
          paused ? 'm9 5 10 7-10 7Z' : 'M9 6v12M15 6v12'
        );
      }
    }

    listen(previous, 'click', function () {
      change(-1, true);
    });

    listen(next, 'click', function () {
      change(1, true);
    });

    listen(pauseButton, 'click', function () {
      paused = !paused;

      if (paused && busy) {
        settle();
      }

      updatePauseButton();
      schedule();

      if (status) {
        status.textContent = paused
          ? root.dataset.pausedStatus
          : root.dataset.resumedStatus;
      }
    });

    listen(root, 'pointerenter', function (event) {
      if (event.pointerType !== 'mouse') return;

      hovered = true;
      stopTimer();
    });

    listen(root, 'pointerleave', function (event) {
      if (event.pointerType !== 'mouse') return;

      hovered = false;
      schedule();
    });

    listen(root, 'focusin', function () {
      focused = true;
      stopTimer();
    });

    listen(root, 'focusout', function () {
      window.setTimeout(function () {
        if (destroyed) return;

        focused = root.contains(document.activeElement);
        schedule();
      }, 0);
    });

    listen(document, 'visibilitychange', function () {
      if (document.hidden && busy) {
        settle();
      }

      schedule();
    });

    listen(motion, 'change', function (event) {
      if (!event.matches) return;

      paused = true;

      if (busy) {
        settle();
      }

      updatePauseButton();
      stopTimer();
    });

    listen(window, 'resize', function () {
      if (busy) {
        settle();
        schedule();
      }
    });

    function fallbackCopy(value) {
      let active = document.activeElement;
      let input = document.createElement('textarea');

      input.value = value;
      input.setAttribute('readonly', '');
      input.style.cssText =
        'position:fixed;left:-9999px;top:0;font-size:16px;';

      document.body.appendChild(input);

      let copied = false;

      try {
        input.select();
        input.setSelectionRange(0, input.value.length);
        copied = document.execCommand('copy');
      } catch (error) {
        console.error('Top banner fallback copy failed.', error);
      }

      input.remove();

      if (active && typeof active.focus === 'function') {
        active.focus({ preventScroll: true });
      }

      return copied;
    }

    listen(root, 'click', async function (event) {
      if (!(event.target instanceof Element)) return;

      let button = event.target.closest('[data-copy]');
      if (!button || !root.contains(button)) return;

      let code = button.getAttribute('data-copy');
      let state = button.querySelector('.gs-banner__copy-state');
      let copied = false;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        } else {
          copied = fallbackCopy(code);
        }
      } catch (error) {
        copied = fallbackCopy(code);
      }

      if (destroyed) return;

      window.clearTimeout(button.gsCopyTimer);
      button.classList.toggle('is-copied', copied);

      if (state) {
        state.textContent = copied ? root.dataset.copiedState : root.dataset.retryState;
      }

      button.setAttribute(
        'aria-label',
        copied
          ? (root.dataset.copiedAriaTemplate).replaceAll('CODE', code)
          : (root.dataset.copyAriaTemplate).replaceAll('CODE', code)
      );

      if (status) {
        status.textContent = copied
          ? (root.dataset.copySuccessTemplate).replaceAll('CODE', code)
          : (root.dataset.copyFailureTemplate).replaceAll('CODE', code);
      }

      button.gsCopyTimer = window.setTimeout(function () {
        button.classList.remove('is-copied');

        if (state) {
          state.textContent = root.dataset.copyState;
        }

        button.setAttribute(
          'aria-label',
          (root.dataset.copyAriaTemplate).replaceAll('CODE', code)
        );
      }, 2500);
    });

    function destroy() {
      destroyed = true;
      stopTimer();
      settle();
      events.abort();

      root.querySelectorAll('[data-copy]').forEach(function (button) {
        window.clearTimeout(button.gsCopyTimer);
      });
    }

    instances.set(root, destroy);

    settle();
    updatePauseButton();
    schedule();
  }

  function refresh() {
    instances.forEach(function (destroy, root) {
      if (!root.isConnected) {
        destroy();
        instances.delete(root);
      }
    });

    document.querySelectorAll('[data-gs-banner]').forEach(initialise);
  }

  window[KEY] = {
    refresh: refresh
  };

  document.addEventListener('shopify:section:load', refresh);

  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (destroy, root) {
      if (event.target.contains(root)) {
        destroy();
        instances.delete(root);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, {
      once: true
    });
  } else {
    refresh();
  }
})();
